import Speakers from "./sections/Speakers";
import Room from "./sections/Room";
import Points from "./Points";
import CanvasCustom from "./CanvasCustom";
import Hobbies from "./sections/hobbies";
import Library from "./sections/library/Library";
import DeskSection from "./sections/desk";
import Sofa from "./sections/Sofa";
import { Lamp } from "./Lamp";
import { Physics } from "@react-three/cannon";
import { Cursor } from "../../utils/drag";
import { useEffect, useRef } from "react";
import { useTheme } from "../../common/hooks";
import { changeColor, changeIntensity } from "../../animations/lights";
import { Postprocessing } from "./postprocessing";
import WorkExperience from "./sections/experience";
import { CannonDebugger } from "./physics/CannonDebugger";
import { useControls } from "leva";

function ThreeFiber() {
  const ambientLight = useRef(null);
  const pointLight = useRef(null);
  const { theme } = useTheme();
  const { active } = useControls("Physics Debugger", {
    active: false,
  });

  useEffect(() => {
    if (ambientLight.current) {
      changeIntensity(ambientLight.current, theme.ambientLight.intensity, {});
      changeColor(ambientLight.current, theme.ambientLight.color, {
        duration: 2000,
      });
    }
    if (pointLight.current) {
      changeIntensity(pointLight.current, theme.pointLight.intensity);
      changeColor(pointLight.current, theme.pointLight.color, {
        duration: 2000,
      });
    }
  }, [theme]);
  return (
    <CanvasCustom>
      <Physics
        gravity={[0, -9.8, 0]}
        defaultContactMaterial={{
          friction: 0.1,
          restitution: 0.5,
        }}
      >
        <CannonDebugger color="red" active={active}>
          <Cursor />
          <Room />
          <DeskSection />
          <Library />
          <Hobbies />
          <WorkExperience />
          <Speakers />
          <Sofa />
          <Points />
          <ambientLight
            ref={ambientLight}
            intensity={theme.ambientLight.intensity}
            color={theme.ambientLight.color}
          />
          <pointLight
            ref={pointLight}
            color={"ffffff"}
            position={[0, 8, 0]}
            intensity={theme.pointLight.intensity}
          />
          <Lamp position={[0, 6.25, 0]} />
        </CannonDebugger>
      </Physics>
      <Postprocessing />
    </CanvasCustom>
  );
}

export default ThreeFiber;
